
//todo: REMOVE ALL USAGES
const appInsights = {
  trackEvent: () => false,
  trackMetric: () => false,
};

export default Component => Component;
export { appInsights as AI };
